import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StateService } from './states.service';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  constructor(
      private stateService: StateService
  ) { }
  show() {
    this.stateService.updateLoader(true);
  }
  hide() {
    this.stateService.updateLoader(false);
  }
}